<a [routerLink]="['/changelog']">v.{{version}}</a>
